import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "forgot-password" }
const _hoisted_2 = { class: "card-content mx-auto my-auto" }
const _hoisted_3 = { class: "text-title" }
const _hoisted_4 = { class: "p-fluid" }
const _hoisted_5 = {
  key: 0,
  class: "p-field mb-6"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("label", { for: "username" }, "Username", -1)
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "p-error" }
const _hoisted_9 = {
  key: 1,
  class: "p-error"
}
const _hoisted_10 = {
  key: 1,
  class: "p-field mb-6"
}
const _hoisted_11 = /*#__PURE__*/_createVNode("label", { for: "email" }, "Email", -1)
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "p-error" }
const _hoisted_14 = {
  key: 1,
  class: "p-error"
}
const _hoisted_15 = {
  key: 2,
  class: "p-field mb-6"
}
const _hoisted_16 = /*#__PURE__*/_createVNode("label", { for: "idValidatePassword" }, "Password Lama", -1)
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "p-error" }
const _hoisted_19 = {
  key: 1,
  class: "p-error"
}
const _hoisted_20 = {
  key: 3,
  class: "p-field mb-8"
}
const _hoisted_21 = /*#__PURE__*/_createVNode("label", { for: "idNewPassword" }, "Password Baru", -1)
const _hoisted_22 = { key: 0 }
const _hoisted_23 = {
  key: 0,
  class: "p-error"
}
const _hoisted_24 = {
  key: 1,
  class: "p-error"
}
const _hoisted_25 = {
  key: 2,
  class: "p-error"
}
const _hoisted_26 = {
  key: 3,
  class: "p-error"
}
const _hoisted_27 = { class: "mx-auto font-bold text-black" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_Password = _resolveComponent("Password")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("section", _hoisted_2, [
      _createVNode("p", _hoisted_3, _toDisplayString($setup.title), 1),
      _createVNode("form", {
        class: "w-full",
        onSubmit: _cache[5] || (_cache[5] = _withModifiers(($event: any) => ($setup.submitData(!$setup.v$.$invalid)), ["prevent"]))
      }, [
        _createVNode("div", _hoisted_4, [
          ($setup.isForgot())
            ? (_openBlock(), _createBlock("div", _hoisted_5, [
                _hoisted_6,
                _createVNode(_component_InputText, {
                  id: "username",
                  class: "grey-input mt-1",
                  placeholder: "Username",
                  type: "text",
                  modelValue: $setup.v$.username.$model,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ($setup.v$.username.$model = $event))
                }, null, 8, ["modelValue"]),
                ($setup.v$.username.$error && $setup.submitted)
                  ? (_openBlock(), _createBlock("span", _hoisted_7, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.v$.username.$errors, (error, index) => {
                        return (_openBlock(), _createBlock("span", {
                          id: "username-error",
                          key: index
                        }, [
                          _createVNode("small", _hoisted_8, _toDisplayString(error.$message), 1)
                        ]))
                      }), 128))
                    ]))
                  : (($setup.v$.username.$invalid && $setup.submitted) || $setup.v$.username.$pending.$response)
                    ? (_openBlock(), _createBlock("small", _hoisted_9, _toDisplayString($setup.v$.username.required.$message), 1))
                    : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          ($setup.isForgot())
            ? (_openBlock(), _createBlock("div", _hoisted_10, [
                _hoisted_11,
                _createVNode(_component_InputText, {
                  id: "email",
                  class: "grey-input mt-1",
                  placeholder: "John.doe@email.com",
                  type: "text",
                  modelValue: $setup.v$.email.$model,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ($setup.v$.email.$model = $event))
                }, null, 8, ["modelValue"]),
                ($setup.v$.email.$error && $setup.submitted)
                  ? (_openBlock(), _createBlock("span", _hoisted_12, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.v$.email.$errors, (error, index) => {
                        return (_openBlock(), _createBlock("span", {
                          id: "email-error",
                          key: index
                        }, [
                          _createVNode("small", _hoisted_13, _toDisplayString(error.$message), 1)
                        ]))
                      }), 128))
                    ]))
                  : (($setup.v$.email.$invalid && $setup.submitted) || $setup.v$.email.$pending.$response)
                    ? (_openBlock(), _createBlock("small", _hoisted_14, _toDisplayString($setup.v$.email.required.$message), 1))
                    : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (!$setup.isForgot())
            ? (_openBlock(), _createBlock("div", _hoisted_15, [
                _hoisted_16,
                _createVNode(_component_Password, {
                  id: "idValidatePassword",
                  class: "grey-input mt-1",
                  placeholder: "Password Lama",
                  feedback: false,
                  toggleMask: true,
                  modelValue: $setup.v$.validatePassword.$model,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ($setup.v$.validatePassword.$model = $event)),
                  modelModifiers: { trim: true }
                }, null, 8, ["modelValue"]),
                ($setup.v$.validatePassword.$error && $setup.submitted)
                  ? (_openBlock(), _createBlock("span", _hoisted_17, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.v$.validatePassword.$errors, (error, index) => {
                        return (_openBlock(), _createBlock("span", {
                          id: "validasi-password-error",
                          key: index
                        }, [
                          _createVNode("small", _hoisted_18, _toDisplayString(error.$message), 1)
                        ]))
                      }), 128))
                    ]))
                  : (($setup.v$.validatePassword.$invalid && $setup.submitted) || $setup.v$.validatePassword.$pending.$response)
                    ? (_openBlock(), _createBlock("small", _hoisted_19, _toDisplayString($setup.v$.validatePassword.required.$message), 1))
                    : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (!$setup.isForgot())
            ? (_openBlock(), _createBlock("div", _hoisted_20, [
                _hoisted_21,
                _createVNode(_component_Password, {
                  id: "idNewPassword",
                  class: "grey-input mt-1",
                  placeholder: "Password Baru",
                  feedback: false,
                  toggleMask: true,
                  modelValue: $setup.v$.newPassword.$model,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ($setup.v$.newPassword.$model = $event)),
                  modelModifiers: { trim: true }
                }, null, 8, ["modelValue"]),
                (($setup.v$.newPassword.$invalid && $setup.submitted) || $setup.v$.newPassword.$pending.$response)
                  ? (_openBlock(), _createBlock("div", _hoisted_22, [
                      ($setup.v$.newPassword.required.$invalid)
                        ? (_openBlock(), _createBlock("small", _hoisted_23, _toDisplayString(`${$setup.v$.newPassword.required.$message}`), 1))
                        : ($setup.v$.newPassword.specialChar.$invalid)
                          ? (_openBlock(), _createBlock("small", _hoisted_24, _toDisplayString($setup.v$.newPassword.specialChar.$message), 1))
                          : ($setup.v$.newPassword.regexLeast1Numeric.$invalid)
                            ? (_openBlock(), _createBlock("small", _hoisted_25, _toDisplayString($setup.v$.newPassword.regexLeast1Numeric.$message), 1))
                            : ($setup.v$.newPassword.minLength.$invalid)
                              ? (_openBlock(), _createBlock("small", _hoisted_26, _toDisplayString($setup.v$.newPassword.minLength.$message), 1))
                              : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_Button, {
          class: "btn-primary w-full",
          id: "submit-change",
          type: "submit"
        }, {
          default: _withCtx(() => [
            _createVNode("span", _hoisted_27, _toDisplayString($setup.titleButton), 1)
          ]),
          _: 1
        })
      ], 32)
    ])
  ]))
}